export default __webpack_public_path__ + "static/media/bookgamechoice.f1f5e40a.jpg";